var blockedCountries = [
    'DE', 'AT', 'CH', 'ES', 'NL', 'IT', 'PL', 'RU', 'CN', 'JP', 'KR', 'SG', 'MY', 'ID', 'VN', 'FR', 'BR', 'CY', 'BE',
    'AL', 'AD', 'BY', 'BA', 'BG', 'GR', 'XK', 'HR', 'LV', 'LI', 'LT', 'LU', 'MT', 'MD', 'MC', 'ME', 'MK', 'PT', 'RO', 'SM', 
    'RS', 'SK', 'SI', 'CZ', 'UA', 'HU', 'VA'
];

function redirectToBlocked() {
  window.location.href = 'https://www.google.de/';
}

function checkBlockedCountry(countryCode) {
  if (blockedCountries.includes(countryCode)) {
    redirectToBlocked();
  }
}

fetch('https://ipapi.co/json/')
  .then(response => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('HTTP Error ' + response.status);
    }
  })
  .then(data => {
    checkBlockedCountry(data.country_code);
  })
  .catch(function(error) {
    console.log("Error with ipapi, trying backup service", error);
    
    // Backup-Dienst: get.geojs.io
    fetch('https://get.geojs.io/v1/ip/country.json')
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error('HTTP Error ' + response.status);
        }
      })
      .then(data => {
        const countryCode = data.country;
        checkBlockedCountry(countryCode);
      })
      .catch(function(error) {
        console.log("Error with get.geojs.io", error);
      });
  });